import React from 'react'
import Home from 'components/Home'
// import { idpPath, IDP } from '@ctsu/loader'

const AppRoutes = [
  {
    path: '/',
    name: 'Home',
    isExact: true,
    showInMenu: false,
    element: <Home />,
    subRoutes: []
  }
]

export default AppRoutes
